import { makeStyles } from "@material-ui/core";
import ModalWrapper from "@View/components/ModalWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import IconBigPlus from "@View/components/icons/IconBigPlus";
import IconEdit from "@View/components/icons/IconEdit";
import { downloadFile, downloadFileByPath } from "@Dao/api";
import { useDispatch } from "react-redux";
import { getRandomKey } from "@Utils/math";
import { store } from "@State/store";
import { AppActions } from "@State/reducers/getReducers/appReducer";
import { downloadFileViaWebSocket } from "@Utils/websocketDownloader";

const useStyles = makeStyles((_theme) => ({
  cover: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
  },
  item: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    border: "1px solid #F3F5F7",
    background: "rgba(243, 245, 247, 0.5)",
    color: "rgba(26, 30, 36, 1)",
    fontSize: "15px",
    fontWeight: "600",
    lineHeight: "20px",
    textAlign: "center",
    padding: "60px 8px",
    cursor: "pointer",
    "&:hover": {
      color: "rgba(111, 164, 242, 1)",
      borderColor: "rgba(111, 164, 242, 1)",
      background: "rgba(255, 255, 255, 1)",
    },
  },
  icon: {
    width: "36px",
    marginBottom: "10px",
  },
}));

const CreditReportAversModal = ({ open, handleOpen, handleClose, client }) => {
  const { t } = useTranslation();
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();

  const classes = useStyles();

  const closeLocal = () => {
    if (isLoading) return;
    handleClose();
  };

  const loadReport = async (withFA) => {
    const LoadingKey = getRandomKey();
    try {
      setIsLoading(true);
      setError(null);
      dispatch(AppActions.startLoading(LoadingKey));

      await downloadFileViaWebSocket(
        `/api/client/ws/${client.id}/avers-credit-opinion`,
        { type: withFA ? "full" : "change" }
      );

      setIsLoading(false);
      dispatch(AppActions.endLoading(LoadingKey));
      handleClose();

    } catch (error) {
      setError(error.message || t("creditScore.error"));
      setIsLoading(false);
      dispatch(AppActions.endLoading(LoadingKey));
    }
  };

  return (
    <ModalWrapper open={open} handleOpen={handleOpen} handleClose={closeLocal}>
      <div style={{ height: 20 }}></div>
      {error && (
        <div
          style={{ color: "red", marginBottom: "15px", textAlign: "center" }}
        >
          {error}
        </div>
      )}
      <div className={classes.cover}>
        <div
          className={classes.item}
          onClick={() => !isLoading && loadReport(true)}
          style={{
            cursor: isLoading ? "not-allowed" : "pointer",
            opacity: isLoading ? 0.7 : 1,
          }}
        >
          <div>
            <div>
              <IconBigPlus className={classes.icon} />
            </div>
            <div>{t("CreaditOpinion.withFA")}</div>
            {isLoading && (
              <div style={{ marginTop: "10px", fontSize: "12px" }}>
                {t("creditScore.loading")}
              </div>
            )}
          </div>
        </div>
        <div
          className={classes.item}
          onClick={() => !isLoading && loadReport(false)}
          style={{
            cursor: isLoading ? "not-allowed" : "pointer",
            opacity: isLoading ? 0.7 : 1,
          }}
        >
          <div>
            <div>
              <IconEdit className={classes.icon} />
            </div>
            <div>{t("CreaditOpinion.noFA")}</div>
            {isLoading && (
              <div style={{ marginTop: "10px", fontSize: "12px" }}>
                {t("creditScore.loading")}
              </div>
            )}
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default CreditReportAversModal;
